module.exports = __webpack_public_path__ + "static/media/ball_ended_eye_link_horn_holder_twisted.0166da89.webp";